const DOGS_CHANGED_EVENT = 'canebase:dogs-changed';

/** Meldet, dass ein Hund angelegt, geaendert oder geloescht bzw. sein Portrait ersetzt wurde. Die Sidebar laedt ihre
 * Kurzwahl daraufhin neu - sonst bleibt sie bis zum naechsten Seiten-Reload auf dem Stand beim Laden der App. */
export const notifyDogsChanged = () => window.dispatchEvent(new Event(DOGS_CHANGED_EVENT));

/** Meldet sich fuer notifyDogsChanged an; gibt die Abmeldung zurueck (passt direkt als useEffect-Cleanup). */
export const onDogsChanged = (listener: () => void) => {
  window.addEventListener(DOGS_CHANGED_EVENT, listener);
  return () => window.removeEventListener(DOGS_CHANGED_EVENT, listener);
};
